import { render } from "./PurchaseHistory.vue?vue&type=template&id=77b18f8a"
import script from "./PurchaseHistory.vue?vue&type=script&lang=js"
export * from "./PurchaseHistory.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/happy-quiz-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__